/**
 * Colour swatches on a product card preview that colour's photo. The theme
 * binds this to mouseenter only, which never fires on a touch screen, so the
 * swatches sit there looking interactive and doing nothing. This gives a tap
 * the same preview, and a second tap (or a tap elsewhere) puts the card's own
 * photo back.
 *
 * The swap itself is the theme's: the card already carries one
 * [data-variant-title] image per colour, and marking one `is-visible` brings
 * it forward. Only the trigger is added here.
 */
(function () {
  var VISIBLE = 'is-visible';
  var active = null;

  function imagesOf(card) {
    return card.querySelectorAll('[data-variant-title]');
  }

  function clear(card) {
    imagesOf(card).forEach(function (image) {
      image.classList.remove(VISIBLE);
    });
  }

  function preview(swatch) {
    var card = swatch.closest('.product-item');
    if (!card) return;

    var name = swatch.getAttribute('data-swatch-variant-name');
    var wanted = card.querySelector('[data-variant-title="' + CSS.escape(name) + '"]');
    if (!wanted) return;

    // Tapping the swatch that is already showing returns to the default photo.
    if (active === swatch) {
      clear(card);
      active = null;
      return;
    }

    if (active) clear(active.closest('.product-item'));
    clear(card);
    wanted.classList.add(VISIBLE);
    active = swatch;
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-swatch-preview]');

    if (!swatch) {
      // A tap anywhere else drops the preview, so a card is never left showing
      // a colour the shopper has moved on from.
      if (active) {
        clear(active.closest('.product-item'));
        active = null;
      }
      return;
    }

    // The swatch sits inside the card's product link; previewing must not
    // navigate away from the listing.
    event.preventDefault();
    event.stopPropagation();
    preview(swatch);
  });
})();
